/**
 * @title Api Documentation
 * @description Api Documentation
 * @version 1.0
 *
 * Swagger version 2.0
 * Generated at: Mon Feb 15 2021 10:19:46 GMT+0100 (czas środkowoeuropejski standardowy)
 */

import { request } from '../utils/request';
import { API_URLS } from '../utils/config';
import prepareQueryParams from 'utils/prepareQueryParams';

const URL = API_URLS.GUARANTY_SERVICE;

export interface AbstractResponse<D, L> {
  code: string;
  data: D;
  description: string;
  list: Array<L>;
  message: string;
}

export interface GuarValue {
  enddate: string;
  guaramount: number;
  guarid: number;
  guarvalueid: number;
  startdate: string;
  status: string;
}
export interface ConGuarantyResponse {
  beneficiaryname: string;
  beneficiaryreference: string;
  conguarantycoverageamount: number;
  conguarantyendate: string;
  conguarantyoriginalamount: number;
  conguarantystartdate: string;
  conguarantystatus: string;
  conguarantystatusdate: string;
  conguarantystatuslabel: string;
  created_at: string;
  created_by: number;
  ctreference: string;
  ctrid: number;
  currcode: string;
  gassocid: number;
  guaradrcity: string;
  guaradrcountry: string;
  guaradrregion: string;
  guaradrstreet1: string;
  guaradrstreet2: string;
  guaramount: number;
  guarantorname: string;
  guarantorreference: string;
  guardescription: string;
  guardrzipcode: string;
  guarexternalref: string;
  guarflagrenewal: boolean;
  guarid: number;
  guarrank: string;
  guarreceptiondate: string;
  guarreference: string;
  guarremainamount: number;
  guarsignaturedate: string;
  guarstatus: string;
  guarstatusdate: string;
  guarstatuslabel: string;
  guartype: string;
  guartypelabel: string;
  guarusageamount: number;
  propreference: string;
  tpidbeneficiary: number;
  tpidguarantor: number;
  updated_at: string;
  updated_by: number;
}
export interface MgGuaranty {
  guarcode: string;
  mgid: number;
}
export interface GuarBeneficiaryRequest {
  enddate: string;
  guarassocid: number;
  guarid: number;
  guarusageamount: number;
  startdate: string;
  tpidbeneficiary: number;
}

export interface GuarBeneficiaryResponse {
  enddate: string;
  guarassocid: number;
  guarid: number;
  guarstatus: string;
  guarstatusdate: string;
  guarusageamount: number;
  startdate: string;
  statuslabel: string;
  tpidbeneficiary: number;
  tpname: string;
  tpreference: string;
}

export interface GuarContractResponse {
  clientname: string;
  clientreference: string;
  coverageamount: number;
  ctreference: string;
  propreference: string;
  ctrid: number;
  endate: string;
  gassocid: number;
  guarid: number;
  startdate: string;
  status: string;
  statusdate: string;
  statuslabel: string;
  tpidclient: number;
}

export interface GuarantyListSearchResponse {
  beneficiaryname: string;
  beneficiaryreference: string;
  ctreference: string;
  ctrid: number;
  guaramount: number;
  guarantorname: string;
  guardescription: string;
  guarexternalref: string;
  guarid: number;
  guarreference: string;
  guarremainamount: number;
  guarsignaturedate: string;
  guarstatus: string;
  guartype: string;
  propreference: string;
  refguarantor: string;
  statuslabel: string;
  tpidbeneficiary: number;
  tpidguarantor: number;
  typelabel: string;
  currcode?: string;
  guarcode: string;
}

export interface GuarantyRequest {
  conguarantystartdate: string;
  coverageamount: number;
  created_at: string;
  created_by: number;
  ctrid: number;
  currcode: string;
  gassocid: number;
  guaradrcity: string;
  guaradrcountry: string;
  guaradrregion: string;
  guaradrstreet1: string;
  guaradrstreet2: string;
  guaramount: number;
  guardescription: string;
  guardrzipcode: string;
  guarexternalref: string;
  guarflagrenewal: boolean;
  guarid: number;
  guarrank: string;
  guarreceptiondate: string;
  guarreference: string;
  guarremainamount: number;
  guarsignaturedate: string;
  guarstatus: string;
  guarstatusdate: string;
  guartype: string;
  guarusageamount: number;
  mgid: number;
  tpidbeneficiary: number;
  tpidguarantor: number;
  updated_at: string;
  updated_by: number;
}
export interface ParGuaranty {
  id?: number;
  editing?: boolean;
  guarcode: string;
  guarlabel: string;
  guartype: string;
  flagaddauto:boolean;
  applicationrule: string;
  year10coveragecoef: number;
  year1coveragecoef: number;
  year2coveragecoef: number;
  year3coveragecoef: number;
  year4coveragecoef: number;
  year5coveragecoef: number;
  year6coveragecoef: number;
  year7coveragecoef: number;
  year8coveragecoef: number;
  year9coveragecoef: number;
  isNew?: true,
}

export interface Mgprovision {
  flagassetmarketvalue: boolean;
  flagguaranty: boolean;
  flagoutstandingcapital: boolean;
  flagoutstandinginterest: boolean;
  flagtax: boolean;
  initialclass: string;
  mgid: number;
  mgprovid: number;
  nbdays: number;
  provisioncoef: number;
  targetclass: string;
}
export interface GuarantyResponse {
  beneficiaryname: string;
  beneficiaryreference: string;
  created_at: string;
  created_by: number;
  currcode: string;
  guaradrcity: string;
  guaradrcountry: string;
  guaradrregion: string;
  guaradrstreet1: string;
  guaradrstreet2: string;
  guaramount: number;
  guarantorname: string;
  guarantorreference: string;
  guardescription: string;
  guardrzipcode: string;
  guarexternalref: string;
  guarflagrenewal: boolean;
  guarid: number;
  guarrank: string;
  guarreceptiondate: string;
  guarreference: string;
  guarremainamount: number;
  guarsignaturedate: string;
  guarstatus: string;
  guarstatusdate: string;
  guartype: string;
  guartypelabel: string;
  guarusageamount: number;
  mgid: number;
  statuslabel: string;
  tpidbeneficiary: number;
  tpidguarantor: number;
  updated_at: string;
  updated_by: number;
  guarcode: string;
}

export interface FindGuarantyListByAnyRefParams {
  beneficiaryname: string;
  beneficiaryreference: string;
  ctreference: string;
  guarantorname: string;
  guarreference: string;
  guarstatus: string;
  guartype: string;
  propreference: string;
  refguarantor: string;
  guarcode: string;
  tpidbeneficiary: number;
  tpidguarantor: number;
}
export interface GetGuarValueByIdParams {
  guarid: number;
};


/**
 * @tags Guaranty Value Controller
 * @summary getGuarValueById
 */
export function getGuarValueById (params: GetGuarValueByIdParams) {
  return request.get<AbstractResponse<object,GuarValue>>(`${URL}/api/guarvalue/${params.guarid}`)
};

/**
 * @tags Guaranty Controller
 * @summary findGuarantyListByAnyRef
 */
export function findGuarantyListByAnyRef(
  params: FindGuarantyListByAnyRefParams
) {
  return request.get<AbstractResponse<object, GuarantyListSearchResponse>>(
    `${URL}/api/guaranty` +
      prepareQueryParams({
        beneficiaryname: params.beneficiaryname,
        beneficiaryreference: params.beneficiaryreference,
        ctreference: params.ctreference,
        guarantorname: params.guarantorname,
        guarreference: params.guarreference,
        guarstatus: params.guarstatus,
        guartype: params.guartype,
        propreference: params.propreference,
        refguarantor: params.refguarantor,
        tpidbeneficiary: params?.tpidbeneficiary,
        tpidguarantor: params?.tpidguarantor,
        guarcode: params?.guarcode,
      } as any)
  );
}

export interface CreateGuarantyParams {
  guarRequest: GuarantyRequest;
}

/**
 * @tags Guaranty Controller
 * @summary createGuaranty
 */
export function createGuaranty(params: CreateGuarantyParams) {
  return request.post<AbstractResponse<GuarantyResponse, object>>(
    `${URL}/api/guaranty`,
    params.guarRequest
  );
}

export interface GetGuarantyByIDParams {
  guarid: number;
}

/**
 * @tags Guaranty Controller
 * @summary Get a Guaranty Detail. returns .data
 */
export function getGuarantyByID(params: GetGuarantyByIDParams) {
  return request.get<AbstractResponse<GuarantyResponse, object>>(
    `${URL}/api/guaranty/${params.guarid}`
  );
}

export interface UpdateGuarantyParams {
  guarRequest: GuarantyRequest;
  guarid: number;
}

/**
 * @tags Guaranty Controller
 * @summary updateGuaranty
 */
export function updateGuaranty(params: UpdateGuarantyParams) {
  return request.put<AbstractResponse<GuarantyResponse, object>>(
    `${URL}/api/guaranty/${params.guarid}`,
    params.guarRequest
  );
}

export interface GetGuarBeneficiaryListParams {
  guarid: number;
}

/**
 * @tags Guaranty Controller
 * @summary getGuarBeneficiaryList
 */
export function getGuarBeneficiaryList(params: GetGuarBeneficiaryListParams) {
  return request.get<AbstractResponse<object, GuarBeneficiaryResponse>>(
    `${URL}/api/guaranty/${params.guarid}/beneficiary`
  );
}

export interface AddGuarBeneficiaryParams {
  benef: GuarBeneficiaryRequest;
  guarid: number;
}

/**
 * @tags Guaranty Controller
 * @summary addGuarBeneficiary
 */
export function addGuarBeneficiary(params: AddGuarBeneficiaryParams) {
   

  return request.post<AbstractResponse<GuarBeneficiaryResponse, object>>(
    `${URL}/api/guaranty/${params.guarid}/beneficiary`,
    params.benef
  );
}

export interface GetGuarBeneficiaryParams {
  gassocid: number;
  guarid: number;
}

/**
 * @tags Guaranty Controller
 * @summary getGuarBeneficiary
 */
export function getGuarBeneficiary(params: GetGuarBeneficiaryParams) {
  return request.get<AbstractResponse<GuarBeneficiaryResponse, object>>(
    `${URL}/api/guaranty/${params.guarid}/beneficiary/${params.gassocid}`
  );
}

export interface UpdateGuarBeneficiaryParams {
  benef: GuarBeneficiaryRequest;
  gassocid: number;
  guarid: number;
}

/**
 * @tags Guaranty Controller
 * @summary updateGuarBeneficiary
 */
export function updateGuarBeneficiary(params: UpdateGuarBeneficiaryParams) {
  return request.put<AbstractResponse<GuarBeneficiaryResponse, object>>(
    `${URL}/api/guaranty/${params.guarid}/beneficiary/${params.gassocid}`,
    params.benef
  );
}

export interface RemoveGuarBeneficiaryParams {
  gassocid: number;
  guarid: number;
}

/**
 * @tags Guaranty Controller
 * @summary removeGuarBeneficiary
 */
export function removeGuarBeneficiary(params: RemoveGuarBeneficiaryParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/guaranty/${params.guarid}/beneficiary/${params.gassocid}`
  );
}

export interface UpdateGuarBeneficiaryStatusParams {
  gassocid: number;
  guarid: number;
  status: string;
}

/**
 * @tags Guaranty Controller
 * @summary updateGuarBeneficiaryStatus
 */
export function updateGuarBeneficiaryStatus(
  params: UpdateGuarBeneficiaryStatusParams
) {
  return request.put<AbstractResponse<GuarBeneficiaryResponse, object>>(
    `${URL}/api/guaranty/${params.guarid}/beneficiary/${params.gassocid}/updateStatus/${params.status}`
  );
}

export interface GetConGuarantyParams {
  guarid: number;
}

/**
 * @tags Guaranty Controller
 * @summary getConGuaranty
 */
export function getConGuaranty(params: GetConGuarantyParams) {
  return request.get<AbstractResponse<object, GuarContractResponse>>(
    `${URL}/api/guaranty/${params.guarid}/contract`
  );
}

export interface UpdateConGuarantyStatusParams {
  gassocid: number;
  guarid: number;
  status: string;
}

/**
 * @tags Guaranty Controller
 * @summary updateConGuarantyStatus
 */
export function updateConGuarantyStatus(params: UpdateConGuarantyStatusParams) {
  return request.put<AbstractResponse<ConGuarantyResponse, object>>(
    `${URL}/api/guaranty/${params.guarid}/contract/${params.gassocid}/updateStatus/${params.status}`
  );
}

export interface UpdateGuarantyStatusParams {
  guarid: number;
  status: string;
}

/**
 * @tags Guaranty Controller
 * @summary updateGuarantyStatus
 */
export function updateGuarantyStatus(params: UpdateGuarantyStatusParams) {
  return request.put<AbstractResponse<GuarantyResponse, object>>(
    `${URL}/api/guaranty/${params.guarid}/updateStatus/${params.status}`
  );
}

export interface GetGuarantyListByCTRIDParams {
  ctrid: number;
}

/**
 * @tags Guaranty Controller
 * @summary Get a Guaranty List by Contract ID. returns .list
 */
export function getGuarantyListByCTRID(params: GetGuarantyListByCTRIDParams) {
  return request.get<AbstractResponse<object, ConGuarantyResponse>>(
    `${URL}/api/guarantylist/${params.ctrid}`
  );
}

/**
 * @tags Guaranty Value Controller
 * @summary getGuarValueList
 */
export function getGuarValueList() {
  return request.get<AbstractResponse<object, GuarValue>>(
    `${URL}/api/guarvalue`
  );
}

export interface UpdateGuarValueParams {
  guarvalueid: number;
  request: GuarValue;
}

/**
 * @tags Guaranty Value Controller
 * @summary UpdateGuarValue
 */
export function UpdateGuarValue(params: UpdateGuarValueParams) {
  return request.put<AbstractResponse<GuarValue, object>>(
    `${URL}/api/guarvalue/${params.guarvalueid}`,
    params.request
  );
}

export interface AddMgGuarantyParams {
  request: MgGuaranty;
}

/**
 * @tags Mg Guaranty Controller
 * @summary AddMgGuaranty
 */
export function AddMgGuaranty(params: AddMgGuarantyParams) {
  return request.post<AbstractResponse<MgGuaranty, object>>(
    `${URL}/api/mgguaranty`,
    params.request
  );
}

export interface RemoveMgGuarantyParams {
  guarcode: string;
}

/**
 * @tags Mg Guaranty Controller
 * @summary RemoveMgGuaranty
 */
export function RemoveMgGuaranty(params: RemoveMgGuarantyParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/mgguaranty/${params.guarcode}`
  );
}

/**
 * @tags Mg Provision Controller
 * @summary getMgprovisionList
 */
export function getMgprovisionList() {
  return request.get<AbstractResponse<object, Mgprovision>>(
    `${URL}/api/mgprovision`
  );
}

export interface AddMgprovisionParams {
  request: Mgprovision;
}

/**
 * @tags Mg Provision Controller
 * @summary AddMgprovision
 */
export function AddMgprovision(params: AddMgprovisionParams) {
  return request.post<AbstractResponse<Mgprovision, object>>(
    `${URL}/api/mgprovision`,
    params.request
  );
}

export interface UpdateMgprovisionParams {
  mgprovid: number;
  request: Mgprovision;
}

/**
 * @tags Mg Provision Controller
 * @summary UpdateMgprovision
 */
export function UpdateMgprovision(params: UpdateMgprovisionParams) {
  return request.put<AbstractResponse<Mgprovision, object>>(
    `${URL}/api/mgprovision/${params.mgprovid}`,
    params.request
  );
}

export interface RemoveMgprovisionParams {
  mgprovid: number;
}

/**
 * @tags Mg Provision Controller
 * @summary RemoveMgprovision
 */
export function RemoveMgprovision(params: RemoveMgprovisionParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/mgprovision/${params.mgprovid}`
  );
}

export interface GetParGuarantyByCriteriaParams {
  guarlabel: string;
  guartype: string;
}

/**
 * @tags Par Guaranty Controller
 * @summary getParGuarantyByCriteria
 */
export function getParGuarantyByCriteria(
  params: GetParGuarantyByCriteriaParams
) {
  return request.get<AbstractResponse<object, ParGuaranty>>(
    `${URL}/api/parguaranty` +
      prepareQueryParams({
        guarlabel: params.guarlabel,
        guartype: params.guartype,
      } as any)
  );
}

export interface AddParGuarantyParams {
  request: ParGuaranty;
}

/**
 * @tags Par Guaranty Controller
 * @summary AddParGuaranty
 */
export function AddParGuaranty(params: AddParGuarantyParams) {
  return request.post<AbstractResponse<ParGuaranty, object>>(
    `${URL}/api/parguaranty`,
    params.request
  );
}

export interface UpdateParGuarantyParams {
  guarcode: string;
  request: ParGuaranty;
}

/**
 * @tags Par Guaranty Controller
 * @summary UpdateParGuaranty
 */
export function UpdateParGuaranty(params: UpdateParGuarantyParams) {
  return request.put<AbstractResponse<ParGuaranty, object>>(
    `${URL}/api/parguaranty/${params.guarcode}`,
    params.request
  );
}

export interface RemoveParGuarantyParams {
  guarcode: string;
}

/**
 * @tags Par Guaranty Controller
 * @summary RemoveParGuaranty
 */
export function RemoveParGuaranty(params: RemoveParGuarantyParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/parguaranty/${params.guarcode}`
  );
}

/**
 * @tags Guaranty Controller
 * @summary version
 */
export function version() {
  return request.get<string>(`${URL}/api/version`);
}
export interface GetMgGuarantyListParams {
  mgid: number;
}


/**
 * @tags Mg Guaranty Controller
 * @summary getMgGuarantyList
 */
export function getMgGuarantyList (params: GetMgGuarantyListParams) {
  return request.get<AbstractResponse<object,MgGuaranty>>(`${URL}/api/mgguaranty` + prepareQueryParams({mgid: params.mgid} as any))
}